import Vue from 'vue'
import Nprogress from 'nprogress'
import App from './App.vue'
import router from './router'
import store from './store'
import Message from 'vue-m-message'
import MDialog from 'vue-m-dialog/dist'
import ElementUI from 'element-ui'
import 'jquery'
import { isProd } from './utils'
import 'nprogress/nprogress.css'
import 'vue-m-dialog/dist/css/default.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/main.less'
import '@/plugins/index'
import moment from 'moment'
import qs from 'qs'
import 'interceptors'
import VueAxios from 'vue-axios'
import axios from 'axios'

Vue.use(VueAxios, axios)

Vue.prototype.$qs = qs


import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)



Vue.prototype.$moment = moment

Vue.filter('moment', function (value, formatString) {
  formatString = formatString || 'YYYY-MM-DD';
  return moment(value).format(formatString);
});

Vue.filter('moment0', function (value, formatString) {
  formatString = formatString || 'YYYY-MM-DD hh:mm:ss';
  return moment(value).format(formatString);
});

Vue.filter('moment1', function (value, formatString) {
  formatString = formatString || 'YYYY-MM-DD hh:mm';
  return moment(value).format(formatString);
});

Vue.use(Message, { name: 'msg' }) // mount `Vue.prototype.$msg`
Vue.use(MDialog, {
  dialogName: 'm-dialog',
  alertName: 'malert',
  confirmName: 'mconfirm'
})
Vue.use(ElementUI)

Vue.config.productionTip = false

router.beforeEach((to, form, next) => {
  Nprogress.start()


  // if(to.name != "/" && localStorage.getItem("users")==null){
  //   alert("请先登录")
  //   this.$router.replace({path:''})
  // }else
  // if(to.name == "/"){
  //   next()
  // } else {
  //   let users = localStorage.getItem("users")
  //   users ? next() : next("/")
  // }
  next()
})


router.afterEach(transition => {
  setTimeout(() => {
    Nprogress.done()
  })
})

const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.app = isProd() ? undefined : app
